/* eslint-disable react/jsx-props-no-spreading */

'use client';

import { useState } from 'react';
import Markdown from 'markdown-to-jsx';

// Import styles
import './faq.css';

const FAQClient = ({ faqItems }) => {
  const [activeItem, setActiveItem] = useState(0);

  const toggleItem = (index) => {
    setActiveItem(activeItem === index ? -1 : index);
  };

  return (
    <div className="faq-section my-3">
      <div className="faq-header text-center mb-4">
        <h3 className="faq-title mb-3">
          <i className="fas fa-question-circle text-primary me-2" />
          Frequently Asked Questions
        </h3>
        <p className="text-muted">Find answers to common questions about this topic</p>
      </div>
      {faqItems.length > 0 ? (
        <div className="faq-items">
          {faqItems.map((item, index) => (
            <div key={item.id} className="faq-item mb-2">
              <div className="faq-question-container">
                <button
                  className={`faq-button w-100 text-start p-4 bg-white border rounded-3 shadow-sm transition-all duration-300 ${
                    activeItem === index ? 'hover:shadow-md' : ''
                  }`}
                  type="button"
                  onClick={() => toggleItem(index)}
                  aria-expanded={activeItem === index}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="faq-question mb-0 fw-semibold text-dark">
                      {item.question.replace(/^####+\s+/, '').trim()}
                    </h5>
                    <i
                      className={`fas fa-chevron-down text-primary faq-icon transition-transform duration-300 ${
                        activeItem === index ? 'rotate-180' : ''
                      }`}
                    />
                  </div>
                </button>
              </div>
              <div
                className={`faq-answer ${activeItem === index ? 'show' : ''}`}
                style={{
                  display: activeItem === index ? 'block' : 'none',
                }}
              >
                <div className="p-4 pt-2 bg-light rounded-bottom-3">
                  <div className="faq-answer-content text-dark">
                    <Markdown
                      options={{
                        overrides: {
                          p: (props) => <p className="mb-1" {...props} />,
                          ol: (props) => <ol className="text-dark mt-3" {...props} />,
                          ul: (props) => <ul className="text-dark" {...props} />,
                          dl: (props) => <dl className="row text-dark mt-3" {...props} />,
                          dt: (props) => <dt className="col-sm-3" {...props} />,
                          dd: (props) => <dd className="col-sm-9" {...props} />,
                          a: ({ href, children }) => (
                            <a href={href} target="_blank" rel="noopener noreferrer">
                              {children}
                            </a>
                          ),
                        },
                      }}
                    >
                      {item.answer}
                    </Markdown>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="alert alert-info text-center">
          <i className="fas fa-info-circle me-2" />
          No FAQ items found. Please check your markdown syntax.
        </div>
      )}
    </div>
  );
};

export default FAQClient;
